import React from 'react'

export default function PremiumIcon(props) {
	return (
		<svg
			width={249}
			height={49}
			viewBox="0 0 249 49"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			{...props}
		>
			<title>Premium Icon</title>
			<defs>
				<path id="a" d="M0 20.667h28.667V0H0v9.333z" />
				<path
					id="b"
					d="M4.795 11.425L15.098.205l1.715 1.642L4.927 14.79l-4.74-4.397 1.582-1.777z"
				/>
				<path id="d" d="M0 20.667h28.667V0H0v9.333z" />
				<path
					id="e"
					d="M4.795 11.425L15.098.205l1.715 1.642L4.927 14.79l-4.74-4.397 1.582-1.777z"
				/>
				<path id="g" d="M0 20.667h28.667V0H0v9.333z" />
				<path
					id="h"
					d="M4.795 11.425L15.098.205l1.715 1.642L4.927 14.79l-4.74-4.397 1.582-1.777z"
				/>
			</defs>
			<g fill="none" fillRule="evenodd">
				<path
					d="M39.79 36.488h3.151v3.09l-7.44 4.154-7.442-4.155v-3.09h3.152c1.058 1.12 2.583 1.815 4.291 1.815 1.704 0 3.23-.696 4.287-1.814zm-4.289-.512c-2.109 0-3.811-1.62-3.797-3.698-.014-2.056 1.688-3.693 3.794-3.693 2.11 0 3.812 1.637 3.798 3.693.014 2.078-1.688 3.698-3.795 3.698z"
					fill="#FFF"
					fillRule="nonzero"
				/>
				<path
					d="M46 33.491l-4.479-6.96-.956-.537-5.065-2.847L25 29.05v12.78l10.5 5.902L46 41.83v-8.339z"
					stroke="#FFF"
					strokeWidth={2}
				/>
				<path
					d="M15.79 36.488h3.151v3.09l-7.44 4.154-7.442-4.155v-3.09H7.21c1.058 1.12 2.583 1.815 4.291 1.815 1.704 0 3.23-.696 4.287-1.814zm-4.289-.512c-2.109 0-3.811-1.62-3.797-3.698-.014-2.056 1.688-3.693 3.794-3.693 2.11 0 3.812 1.637 3.798 3.693.014 2.078-1.688 3.698-3.795 3.698z"
					fill="#FFF"
					fillRule="nonzero"
				/>
				<path
					d="M22 41.83V29.05l-5.435-3.055-5.065-2.847L1 29.05v12.78l10.5 5.902L22 41.83z"
					stroke="#FFF"
					strokeWidth={2}
				/>
				<path
					d="M27.79 14.488h3.151v3.09l-7.44 4.154-7.442-4.155v-3.09h3.152c1.058 1.12 2.583 1.815 4.291 1.815 1.704 0 3.23-.696 4.287-1.814zm-4.289-.512c-2.109 0-3.811-1.62-3.797-3.698-.014-2.056 1.688-3.693 3.794-3.693 2.11 0 3.812 1.637 3.798 3.693.014 2.078-1.688 3.698-3.795 3.698z"
					fill="#FFF"
					fillRule="nonzero"
				/>
				<path
					d="M34 19.83V7.05l-5.435-3.055L23.5 1.147 13 7.05v12.78l10.5 5.902L34 19.83z"
					stroke="#FFF"
					strokeWidth={2}
				/>
				<path
					d="M69.667 31.667H42.333V33H71V12.333h-1.333v19.334z"
					fillOpacity=".2"
					fill="#000"
					fillRule="nonzero"
				/>
				<g fillRule="nonzero" transform="translate(41 11)">
					<use fill="#FFF" fillRule="evenodd" xlinkHref="#a" />
					<path stroke="#FFF" d="M.5 20.167h27.667V.5H.5v19.667z" />
				</g>
				<path
					fill="#1B212D"
					d="M45 15.667h20.667V17H45zM45 21h12v1.333H45zm14 0h6.667v1.333H59zm-14 5.333h3.333v1.333H45zm6 0h12v1.333H51z"
				/>
				<g transform="translate(66 5)">
					<mask id="c" fill="#fff">
						<use xlinkHref="#b" />
					</mask>
					<use fill="var(--nomad,#60dea9)" xlinkHref="#b" />
					<g mask="url(#c)" fill="var(--nomad,#60dea9)">
						<path d="M0 0h17v15H0z" />
					</g>
				</g>
				<path
					d="M122.79 36.488h3.151v3.09l-7.44 4.154-7.442-4.155v-3.09h3.152c1.058 1.12 2.583 1.815 4.291 1.815 1.704 0 3.23-.696 4.287-1.814zm-4.289-.512c-2.109 0-3.811-1.62-3.797-3.698-.014-2.056 1.688-3.693 3.794-3.693 2.11 0 3.812 1.637 3.798 3.693.014 2.078-1.688 3.698-3.795 3.698z"
					fill="#FFF"
					fillRule="nonzero"
				/>
				<path
					d="M129 33.491l-4.479-6.96-.956-.537-5.065-2.847L108 29.05v12.78l10.5 5.902L129 41.83v-8.339z"
					stroke="#FFF"
					strokeWidth={2}
				/>
				<path
					d="M98.79 36.488h3.151v3.09l-7.44 4.154-7.442-4.155v-3.09h3.152c1.058 1.12 2.583 1.815 4.291 1.815 1.704 0 3.23-.696 4.287-1.814zm-4.289-.512c-2.109 0-3.811-1.62-3.797-3.698-.014-2.056 1.688-3.693 3.794-3.693 2.11 0 3.812 1.637 3.798 3.693.014 2.078-1.688 3.698-3.795 3.698z"
					fill="#FFF"
					fillRule="nonzero"
				/>
				<path
					d="M105 41.83V29.05l-5.435-3.055-5.065-2.847L84 29.05v12.78l10.5 5.902L105 41.83z"
					stroke="#FFF"
					strokeWidth={2}
				/>
				<path
					d="M110.79 14.488h3.151v3.09l-7.44 4.154-7.442-4.155v-3.09h3.152c1.058 1.12 2.583 1.815 4.291 1.815 1.704 0 3.23-.696 4.287-1.814zm-4.289-.512c-2.109 0-3.811-1.62-3.797-3.698-.014-2.056 1.688-3.693 3.794-3.693 2.11 0 3.812 1.637 3.798 3.693.014 2.078-1.688 3.698-3.795 3.698z"
					fill="#FFF"
					fillRule="nonzero"
				/>
				<path
					d="M117 19.83V7.05l-5.435-3.055-5.065-2.847L96 7.05v12.78l10.5 5.902L117 19.83z"
					stroke="#FFF"
					strokeWidth={2}
				/>
				<path
					d="M152.667 31.667h-27.334V33H154V12.333h-1.333v19.334z"
					fillOpacity=".2"
					fill="#000"
					fillRule="nonzero"
				/>
				<g fillRule="nonzero" transform="translate(124 11)">
					<use fill="#FFF" fillRule="evenodd" xlinkHref="#d" />
					<path stroke="#FFF" d="M.5 20.167h27.667V.5H.5v19.667z" />
				</g>
				<path
					fill="#1B212D"
					d="M128 15.667h20.667V17H128zM128 21h12v1.333h-12zm14 0h6.667v1.333H142zm-14 5.333h3.333v1.333H128zm6 0h12v1.333h-12z"
				/>
				<g transform="translate(149 5)">
					<mask id="f" fill="#fff">
						<use xlinkHref="#e" />
					</mask>
					<use fill="var(--nomad,#60dea9)" xlinkHref="#e" />
					<g mask="url(#f)" fill="var(--nomad,#60dea9)">
						<path d="M0 0h17v15H0z" />
					</g>
				</g>
				<path
					d="M205.79 36.488h3.151v3.09l-7.44 4.154-7.442-4.155v-3.09h3.152c1.058 1.12 2.583 1.815 4.291 1.815 1.704 0 3.23-.696 4.287-1.814zm-4.289-.512c-2.109 0-3.811-1.62-3.797-3.698-.014-2.056 1.688-3.693 3.794-3.693 2.11 0 3.812 1.637 3.798 3.693.014 2.078-1.688 3.698-3.795 3.698z"
					fill="#FFF"
					fillRule="nonzero"
				/>
				<path
					d="M212 33.491l-4.479-6.96-.956-.537-5.065-2.847L191 29.05v12.78l10.5 5.902L212 41.83v-8.339z"
					stroke="#FFF"
					strokeWidth={2}
				/>
				<path
					d="M181.79 36.488h3.151v3.09l-7.44 4.154-7.442-4.155v-3.09h3.152c1.058 1.12 2.583 1.815 4.291 1.815 1.704 0 3.23-.696 4.287-1.814zm-4.289-.512c-2.109 0-3.811-1.62-3.797-3.698-.014-2.056 1.688-3.693 3.794-3.693 2.11 0 3.812 1.637 3.798 3.693.014 2.078-1.688 3.698-3.795 3.698z"
					fill="#FFF"
					fillRule="nonzero"
				/>
				<path
					d="M188 41.83V29.05l-5.435-3.055-5.065-2.847L167 29.05v12.78l10.5 5.902L188 41.83z"
					stroke="#FFF"
					strokeWidth={2}
				/>
				<path
					d="M193.79 14.488h3.151v3.09l-7.44 4.154-7.442-4.155v-3.09h3.152c1.058 1.12 2.583 1.815 4.291 1.815 1.704 0 3.23-.696 4.287-1.814zm-4.289-.512c-2.109 0-3.811-1.62-3.797-3.698-.014-2.056 1.688-3.693 3.794-3.693 2.11 0 3.812 1.637 3.798 3.693.014 2.078-1.688 3.698-3.795 3.698z"
					fill="#FFF"
					fillRule="nonzero"
				/>
				<path
					d="M200 19.83V7.05l-5.435-3.055-5.065-2.847L179 7.05v12.78l10.5 5.902L200 19.83z"
					stroke="#FFF"
					strokeWidth={2}
				/>
				<path
					d="M235.667 31.667h-27.334V33H237V12.333h-1.333v19.334z"
					fillOpacity=".2"
					fill="#000"
					fillRule="nonzero"
				/>
				<g fillRule="nonzero" transform="translate(207 11)">
					<use fill="#FFF" fillRule="evenodd" xlinkHref="#g" />
					<path stroke="#FFF" d="M.5 20.167h27.667V.5H.5v19.667z" />
				</g>
				<path
					fill="#1B212D"
					d="M211 15.667h20.667V17H211zM211 21h12v1.333h-12zm14 0h6.667v1.333H225zm-14 5.333h3.333v1.333H211zm6 0h12v1.333h-12z"
				/>
				<g transform="translate(232 5)">
					<mask id="i" fill="#fff">
						<use xlinkHref="#h" />
					</mask>
					<use fill="var(--nomad,#60dea9)" xlinkHref="#h" />
					<g mask="url(#i)" fill="var(--nomad,#60dea9)">
						<path d="M0 0h17v15H0z" />
					</g>
				</g>
			</g>
		</svg>
	)
}
